import * as React from 'react';
import type { DynamicComponentProps } from '@/types/commontypes';
import { Checkbox } from 'antd';
import type { CheckboxProps } from 'antd';

const CheckboxProperty: React.FC<DynamicComponentProps<boolean>> = ({ label, value = true, onChange }) => {
  const [checked, setChecked] = React.useState(value);

  // Sync internal state with prop value when it changes
  React.useEffect(() => {
    setChecked(value);
  }, [value]);

  const handleChange: CheckboxProps['onChange'] = e => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    onChange(isChecked);
  };

  return (
    <div style={{ gridColumn: 'span 2' }}>
      <Checkbox checked={!!checked} onChange={handleChange}>
        {label}
      </Checkbox>
    </div>
  );
};

export default CheckboxProperty;
